import { useState, useCallback } from 'react';

const useClasses = () => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchClasses = useCallback(async (projectId) => {
    if (!projectId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(`/api/projects/${projectId}/classes`, {
        headers: { 'x-auth-token': localStorage.getItem('token') }
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.msg || 'Failed to fetch classes');
      setClasses(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const addClass = async (projectId, name, isActive = true) => {
    try {
      const res = await fetch(`/api/projects/${projectId}/classes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': localStorage.getItem('token')
        },
        body: JSON.stringify({ name, isActive })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.errors?.[0]?.msg || data.msg || 'Failed to add class');
      setClasses(prev => [...prev, data].sort((a, b) => a.name.localeCompare(b.name)));
      return { success: true, data };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const updateClass = async (projectId, classId, name, isActive) => {
    try {
      const res = await fetch(`/api/projects/${projectId}/classes/${classId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': localStorage.getItem('token')
        },
        body: JSON.stringify({ name, isActive })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.errors?.[0]?.msg || data.msg || 'Failed to update class');
      setClasses(prev => prev.map(c => (c._id === classId ? data : c)).sort((a, b) => a.name.localeCompare(b.name)));
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  return { classes, loading, error, fetchClasses, addClass, updateClass };
};

export default useClasses;
